export default "__VITE_ASSET__a1c3ed2b__"